<template>
  <div class="man" ref="manBox">
    <div class="man_l" ref="navBox">
      <div class="logo">
        <img :src="defaultLogo" alt="" class="logo_img" />
        <div class="logo-text">
          <span>{{ brandName }}</span>
          <small v-if="isPlatformAdmin" class="logo-sub">{{ platformRemark }}</small>
        </div>
      </div>
      <SideBar ref="sideBar" @childer="childerClick($event)" />
    </div>
    <div class="content">
      <div class="content_top">
        <heade @tips="tips($event)" />
      </div>
      <div v-if="state.subscriptionReminder" class="subscription-alert">
        <el-alert
          :title="state.subscriptionReminder.message"
          type="warning"
          show-icon
          :closable="true"
          @close="state.subscriptionReminder = null"
        />
      </div>
      <div class="content_man" :class="{ 'content_man--subnav': showSubMenu }">
        <div
          v-if="showSubMenu && !isMobile"
          class="content_subnav"
          role="navigation"
          :aria-label="t('subNav')"
        >
          <routing />
        </div>
        <div class="page-view" :class="{ 'page-view--with-subnav': showSubMenu && !isMobile }">
          <hc-page-header
            v-if="showPageHeader"
            :show-subnav-toggle="showSubMenu && isMobile"
            @open-subnav="subnavDrawer = true"
          />
          <transition name="fade" mode="out-in">
            <router-view />
          </transition>
        </div>
      </div>
      <el-drawer
        v-model="subnavDrawer"
        direction="ltr"
        size="260px"
        :title="userData.userRouter?.title || t('subNav')"
        class="subnav-drawer"
      >
        <routing @navigate="subnavDrawer = false" />
      </el-drawer>
    </div>
  </div>
</template>

<script setup>
import SideBar from "./components/sideBar.vue";
import routing from "./components/routing.vue";
import heade from "./components/heade.vue";
import hcPageHeader from "@/components/hc-page-header/index.vue";
import { onMounted, ref, reactive, watch, computed } from "vue";
import { useRoute } from "vue-router";
import { resolveTenantApi } from "@/api/login.js";
import defaultLogo from "@/assets/logo.png";
import { getTenantSubscriptionReminder, saveTenantSubscription } from "@/utils/tenantSubscription.js";
import { DEFAULT_BRAND_NAME, PLATFORM_ADMIN_REMARK } from "@/utils/tenantBranding.js";
import { isPlatformAdminSession, getPortalSession, PORTAL_TENANT } from "@/utils/authSession.js";
import { getMenuRoutesForPortal, resolveMenuItemPath } from "@/router/portalRoutes.js";
import { applyMenuPermissionToRoute, filterRoutesByMenuPermissions, getLoginUserMenuPermissions, isSuperAdminRole } from "@/utils/adminMenuPermission.js";
import { isPathMatch } from "@/utils/pageTitle.js";
import { getLoginUser } from "@/utils/loginUser.js";
import { t } from "@/locale/index.js";
import { localizeRouteItem } from "@/utils/menuI18n.js";
import { useMediaMobile } from "@/composables/useMediaMobile.js";

const brandName = DEFAULT_BRAND_NAME
const platformRemark = PLATFORM_ADMIN_REMARK
const isPlatformAdmin = computed(() => isPlatformAdminSession())
const router = useRoute();
import { useStore } from "@/stores/modules/router.js";
const userData = useStore();
const { getRouter, getShow, getClearData } = userData;

const state = reactive({
  boxWidth: 0,
  navBoxWidth: 0,
  boxOffsetHeight: 0,
  element: 0,
  isCollapse: false,
  isTran: false,
  subscriptionReminder: null,
});

const showSubMenu = computed(() => {
  if (isPlatformAdmin.value || router.path.startsWith("/platform")) {
    return false
  }
  return state.isCollapse && Boolean(userData.userRouter?.children?.length)
})

const { isMobile } = useMediaMobile()
const subnavDrawer = ref(false)

const showPageHeader = computed(() => true)

const syncSubMenuForPath = (newPath) => {
  if (isPlatformAdmin.value || newPath.startsWith("/platform")) {
    getClearData()
    state.isCollapse = false
    return
  }
  const user = getLoginUser()
  const permissions = getLoginUserMenuPermissions(user)
  const menuRoutes = filterRoutesByMenuPermissions(
    getMenuRoutesForPortal(PORTAL_TENANT),
    isSuperAdminRole(user?.roleId ?? user?.role_id) ? null : permissions,
  )
  try {
    menuRoutes.forEach((v) => {
      const menuPath = resolveMenuItemPath(v)
      if (!v.children?.length) {
        if (normalizeRoutePath(newPath) === normalizeRoutePath(menuPath)) {
          state.isCollapse = false
          getShow(false)
        }
        return
      }
      if (isPathMatch(newPath, menuPath)) {
        state.isCollapse = true
        childerClick(v)
      }
    })
  } catch {}
}

const normalizeRoutePath = (path) => {
  if (!path) return ''
  const text = String(path)
  return text.length > 1 && text.endsWith('/') ? text.slice(0, -1) : text
}

watch(
  () => router.path,
  (newPath) => {
    syncSubMenuForPath(newPath)
    subnavDrawer.value = false
  },
  { immediate: true }
);

const sideBar = ref();
const refreshSubscriptionReminder = () => {
  if (isPlatformAdminSession()) {
    state.subscriptionReminder = null;
    return;
  }
  const cached = getTenantSubscriptionReminder();
  if (cached) {
    state.subscriptionReminder = cached;
  }
  const tenantCode = getPortalSession(PORTAL_TENANT)?.tenantCode || localStorage.getItem("tenantCode");
  if (!tenantCode) {
    return;
  }
  resolveTenantApi(tenantCode).then((res) => {
    if (res?.code === 200 && res?.data) {
      saveTenantSubscription(res.data);
      state.subscriptionReminder = getTenantSubscriptionReminder();
    }
  }).catch(() => {});
};

// 右侧子菜单
onMounted(() => {
  refreshSubscriptionReminder();
  syncSubMenuForPath(router.path);
});

const childerClick = (item) => {
  userData.num = 0;
  const user = getLoginUser()
  const permissions = getLoginUserMenuPermissions(user)
  const permitted = applyMenuPermissionToRoute(
    item,
    isSuperAdminRole(user?.roleId ?? user?.role_id) ? null : permissions,
  )
  if (!permitted) {
    getClearData()
    state.isCollapse = false
    getShow(false)
    return
  }
  permitted.children ? (state.isCollapse = true) : (state.isCollapse = false);
  getRouter(localizeRouteItem(permitted));
  getShow(state.isCollapse);
};
//收起
const tips = () => {

};
</script>

<style lang="less" scoped>
.content {
  overflow: hidden;
  background-color: var(--tenant-admin-page-bg, var(--admin-canvas-bg, #f5f7fa));
  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.content_top {
  height: 60px;
  flex-shrink: 0;
  background: var(--tenant-admin-header-bg, var(--admin-header-bg, #ffffff));
}

.subscription-alert {
  padding: 0 16px 12px;
}

.man {
  display: flex;
  height: 100vh;
  overflow-x: auto;
}

.logo {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background-color: #0a152e;
  color: #fff;
  padding: 0 12px;
  box-sizing: border-box;
  gap: 12px;

  span {
    margin-left: 0;
    line-height: 1.15;
    text-align: center;
  }

  .logo-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
    margin-left: -3px;

    > span {
      font-weight: 600;
      font-size: 20px;
      line-height: 1.15;
      text-align: left;
    }
  }

  .logo-sub {
    margin-top: 3px;
    font-size: 10px;
    font-weight: 400;
    line-height: 1.2;
    color: rgba(255, 255, 255, 0.65);
    letter-spacing: 0.02em;
    text-align: left;
  }

  .logo_img {
    height: 38px;
    width: 38px;
    margin-left: -4px;
    border-radius: 50%;
    object-fit: contain;
    flex-shrink: 0;
    display: block;
  }
}

.content_man {
  height: calc(100% - 60px);
  display: flex;
  flex: 1;
  min-height: 0;
  background: var(--tenant-admin-page-bg, var(--admin-canvas-bg, #f5f7fa));
}

.content_subnav {
  flex-shrink: 0;
  background: var(--admin-subnav-bg, #ffffff);
  border-right: 1px solid var(--admin-header-border, #e8eaed);
  height: 100%;
}

.page-view {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: var(--admin-page-padding);
  box-sizing: border-box;
  background: var(--tenant-admin-page-bg, var(--admin-canvas-bg, #f5f7fa));
}

.page-view--with-subnav {
  padding-left: 24px;
}

.man_l {
  flex-shrink: 0;
  width: 180px;
  height: 100vh;
  background-color: var(--admin-sidebar-bg, #0a152e);
  display: flex;
  flex-direction: column;
}

/* 渐变设置 */
.fade-enter-from,
.fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.fade-enter-active {
  transition: all 0.7s ease;
}

.fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.6, 0.6, 1);
}
</style>
